export default "__VITE_ASSET__Dsr_SWYo__"